export default class UpdateCommunicationQueue {
  constructor(context) {
    this.context = context;
  }

  run({ communicationQueueId, routingGroupId, name, slaSeconds }) {
    let store = this.context.stores.communicationQueues;
    let communicationQueue = store.find(communicationQueueId);
    if (routingGroupId) {
      communicationQueue.setRoutingGroupId(routingGroupId);
    }
    if (name !== null && name !== undefined) {
      communicationQueue.setName(name);
    }
    if (slaSeconds !== undefined) {
      communicationQueue.setSlaSeconds(slaSeconds);
    }

    store.setPending(communicationQueue);
    this.context.gateways.communicationQueue.update({ queueId: communicationQueueId }, communicationQueue.toJs());
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/channels/update_communication_queue.js